import { useMemo } from 'react';
import { useAppSelector, IApplication, ApplicationStatus, REQUIRED_APPLICATION_LENGTH } from '../utils';
import { isDateAfter, parseDate } from '@utils/dates/date.utils';

export const useIsSepQepDenialButtonAccessible = (application: IApplication) => {
    const userPermissionsList: string[] = useAppSelector(
        state => state.capApplications.capApplicationsInfo.userPermissionList,
    );
    const currentApplications: IApplication[] = useAppSelector(
        state => state.capApplications.capApplicationsInfo.currentApplications,
    );

    return useMemo(() => {
        const hasSepDenialOverridePermission = userPermissionsList.includes('IND_PORTAL_OVERRIDE_SEP_DENIAL');

        const isEligibleApplication = () => {
            return application.isSepQepDenied && application.applicationStatus === ApplicationStatus.Closed;
        };

        const hasValidCurrentApplications = () => {
            if (!currentApplications) {
                return false;
            }

            const isUnderApplicationLimit = currentApplications.length < REQUIRED_APPLICATION_LENGTH;
            const hasValidStatus =
                currentApplications.length === 0 ||
                [ApplicationStatus.EnrolledOrActive, ApplicationStatus.PartiallyEnrolled].includes(
                    currentApplications[0].applicationStatus as ApplicationStatus,
                );

            const isApplicationMoreRecent =
                currentApplications.length === 0 ||
                isDateAfter(parseDate(application.lastUpdated), parseDate(currentApplications[0].lastUpdated));

            return isUnderApplicationLimit && hasValidStatus && isApplicationMoreRecent;
        };

        return hasSepDenialOverridePermission && isEligibleApplication() && hasValidCurrentApplications();
    }, [userPermissionsList, application, currentApplications]);
};
